import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

import { AppDispatch, RootState } from '../../reducers'
import { selectCurrentTrackInfo } from '../../selectors/current-play-selectors'
import loadLocalTimingFromString from './loadLocalTiming'

const KRUMS_URL = 'http://68.183.2.74:5000/api/lrc'

const findAndLoadLyricTimingForTrack = createAsyncThunk<
  { wordCount: number; timedWordCount: number },
  void,
  { state: RootState; dispatch: AppDispatch }
>('findLyricTimingForTrack', async (_, { dispatch, getState }) => {
  const state = getState()
  const trackInfo = selectCurrentTrackInfo(state)
  if (!trackInfo) {
    throw new Error('no track info')
  }
  const { artist, title } = trackInfo
  const config = {
    'content-type': 'application/json',
    headers: {
      // authorization: `Bearer ${userManager.accessToken}`
      title,
      artist,
      album: '',
      cache: 1,
    },
  }
  const {
    data: { code, message },
  } = await axios.get(KRUMS_URL, config)
  if (code !== 200) {
    console.log(code, message)
    return { wordCount: 0, timedWordCount: 0 }
  }
  const result = await dispatch(
    loadLocalTimingFromString({ asReference: false, timingString: message })
  ).unwrap()

  return result
})

export default findAndLoadLyricTimingForTrack
